
import React from 'react'
import FooterMenuItem from './footermenuitem'

function FooterMenu({ menu }) {
    return (
        <FooterMenuItem menuTree={menu}></FooterMenuItem>     
    );
}

export default FooterMenu;




